export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1776981986368-12b9b05506b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxjYXJhbWVsJTIwbGlxdWlkJTIwcG91cnxlbnwwfHx8fDE3ODcxMjIyODN8MA&ixlib=rb-4.1.0&q=85",
  spices: "https://images.pexels.com/photos/7956504/pexels-photo-7956504.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  scoop: "https://images.pexels.com/photos/39077130/pexels-photo-39077130.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  plant: "https://images.pexels.com/photos/36823725/pexels-photo-36823725.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  spiceBowls: "https://images.pexels.com/photos/36598383/pexels-photo-36598383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  spoonsPowder: "https://images.pexels.com/photos/5078584/pexels-photo-5078584.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  turmeric: "https://images.pexels.com/photos/6979901/pexels-photo-6979901.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  caramelJar: "https://images.pexels.com/photos/7213879/pexels-photo-7213879.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  beetsDark: "https://images.pexels.com/photos/5502850/pexels-photo-5502850.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  tomatoDry: "https://images.pexels.com/photos/18059179/pexels-photo-18059179/free-photo-of-close-up-of-sliced-tomatoes.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  whitePowder: "https://images.pexels.com/photos/7110136/pexels-photo-7110136.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  finePowder: "https://images.pexels.com/photos/8108249/pexels-photo-8108249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bowlPowder: "https://images.pexels.com/photos/7321508/pexels-photo-7321508.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  onionSlice: "https://images.pexels.com/photos/7333168/pexels-photo-7333168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  garlicMortar: "https://images.pexels.com/photos/4871350/pexels-photo-4871350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  greenSifter: "https://images.pexels.com/photos/7615479/pexels-photo-7615479.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CATEGORIES = [
  {
    id: "caramel",
    label: "Caramel Colours",
    code: "CC",
    color: "#E57A3C",
    textTone: "dark",
    blurb:
      "Four classes of caramel colour engineered for beverages, bakery, confectionery and sauces — available in powder and liquid forms.",
    products: [
      { name: "Caramel Colour — Type I", form: "Powder & Liquid" },
      { name: "Caramel Colour — Type II", form: "Liquid" },
      { name: "Caramel Colour — Type III", form: "Powder & Liquid" },
      { name: "Caramel Colour — Type IV", form: "Powder & Liquid" },
    ],
  },
  {
    id: "flavours",
    label: "Food Flavours",
    code: "FF",
    color: "#3E9B4F",
    textTone: "light",
    blurb:
      "Dehydrated, finely milled vegetable and herb powders that lock in natural colour, aroma and taste for industrial food production.",
    products: [
      { name: "Beet Root Powder", form: "Powder" },
      { name: "Bitter Gourd Powder", form: "Powder" },
      { name: "Carrot Powder", form: "Powder" },
      { name: "Cucumber Powder", form: "Powder" },
      { name: "Onion Powder", form: "Powder" },
      { name: "Garlic Powder", form: "Powder" },
      { name: "Ginger Powder", form: "Powder" },
      { name: "Green Chilly Powder", form: "Powder" },
      { name: "Mint Powder", form: "Powder" },
      { name: "Spinach Powder", form: "Powder" },
      { name: "Tomato Powder", form: "Powder" },
    ],
  },
  {
    id: "ingredients",
    label: "Industrial Ingredients",
    code: "II",
    color: "#F5B82A",
    textTone: "dark",
    blurb:
      "Functional starches, sweeteners and preservatives that keep large-scale food manufacturing consistent, batch after batch.",
    products: [
      { name: "Corn Starch", form: "Powder" },
      { name: "Maltodextrin", form: "Powder" },
      { name: "Glucose", form: "Powder & Liquid" },
      { name: "Acetic Acid", form: "Liquid" },
      { name: "Sodium Bi Sulphide", form: "Powder" },
      { name: "Sodium Meta Bi Sulphide", form: "Powder" },
      { name: "Sodium Sulphite", form: "Powder" },
    ],
  },
];

export const MARQUEE_ITEMS = [
  "Beet Root",
  "Onion",
  "Garlic",
  "Ginger",
  "Tomato",
  "Spinach",
  "Mint",
  "Carrot",
  "Caramel Colour",
  "Maltodextrin",
  "Corn Starch",
  "Cucumber",
  "Green Chilly",
  "Bitter Gourd",
];

export const CONTACT = {
  phone: "+91 99136 16190",
  email: "MSDFOODS21@GMAIL.COM",
  headOffice: "C-1, B-130, Phase - II, G.I.D.C. Vatva, Ahmedabad - 382 445, India",
};
